export const formatCurrency = (number: number, traceInZero = false) =>
  number === null
    ? '-'
    : !isNaN(number)
    ? traceInZero
      ? !number
        ? '-'
        : Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number)
      : Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number)
    : '-';
